import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import type { ProjectPlanStepperProps } from '@shared/widget-schemas';
import { capitalizeFirst } from './textFormat';

const stepStyles = {
  completed: { dot: 'bg-success', line: 'bg-success', text: 'text-foreground' },
  active: { dot: 'bg-primary ring-4 ring-primary/20', line: 'bg-muted', text: 'text-primary font-semibold' },
  upcoming: { dot: 'bg-muted', line: 'bg-muted', text: 'text-muted-foreground' },
} as const;

export function ProjectPlanStepperWidget({ phases }: ProjectPlanStepperProps) {
  return (
    <Card className="w-full overflow-x-auto">
      <CardContent className="p-4">
        <div className="flex items-center gap-0 min-w-max">
          {phases.map((phase, i) => {
            const style = stepStyles[phase.status];
            const isLast = i === phases.length - 1;
            return (
              <div key={i} className="flex items-center">
                <div className="flex flex-col items-center gap-1">
                  <div className={cn('h-3 w-3 rounded-full shrink-0', style.dot)} />
                  <span className={cn('text-xs whitespace-nowrap', style.text)}>{capitalizeFirst(phase.label)}</span>
                </div>
                {!isLast && <div className={cn('h-0.5 w-8 mx-1', style.line)} />}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
